'use strict';

var imagesLoaded = require('imagesloaded');
var Utils = require('../utils/utils');

// Constructor
var ArtworkHero = function() {

  var self = this;
  var $window = $(window);

  self.config = {
    'hero'        :  $('.artwork-hero'),
    'image'       :  $('.artwork-hero__image-container img'),
    'caption'     :  $('.artwork-hero__caption-container'),
    'mainHeader'  :  $('.main-header')
  }

  self.setHeight = function() {
    var winHeight = $window.height();
    var headerHeight = self.config.mainHeader.outerHeight();
    var newHeight = winHeight - headerHeight;
    self.config.hero.css('height', newHeight);
    self.setImageDimensions(newHeight);
  }

  self.setImageDimensions = function(heroHeight) {
    var pt = parseInt(self.config.hero.css('padding-top'));
    var pb = parseInt(self.config.hero.css('padding-bottom'));
    var captionHeight = self.config.caption.height();
    var maxHeight = heroHeight - pt - pb - captionHeight;
    self.config.image.css({
      'max-height': maxHeight
    });
    self.imageLoadListener();
  }

  self.imageLoadListener = function() {
    imagesLoaded(self.config.image[0], function() {
      self.config.image.addClass('is-visible');
    });
  }

  self.winResizeHandler = function() {
    $window.on('resize.artworkHero', new Utils().throttle(function() {
      self.setHeight();
    }, 150));
  }

  self.destroy = function() {
    self.config.hero.removeAttr('style');
    self.config.image.removeAttr('style');
    $window.off('resize.artworkHero');
  }

  self.init = function() {
    var largeViewports = function() {
      self.setHeight();
      self.winResizeHandler();
    };
    var smallViewports = function() {
      self.destroy();
      setTimeout(function () {
        self.destroy();
      }, 1000);
    };
    if (self.config.hero.length) {
      new Utils().matchmediaHandler('SMALL', largeViewports, smallViewports);
    }
  }
};

module.exports = ArtworkHero;
